import classNames from 'classnames';
import { ITopArticle, ITopArticlesProps } from './interfaces';
import React from 'react';
import { RichText } from 'prismic-reactjs';
import ArticleLinkImage from '../Articles/ArticleLinkImage';
import { Routes } from '../../../models/enums/routes';
import {
  ArticleAuthor,
  ArticleTitle,
  Fixed,
  Title,
  TopArticleMeta,
  TopArticleWrapper,
  Wrapper,
} from './topArticles.styles';

export const TopArticles = ({
  topArticles,
  contentPage,
}: ITopArticlesProps): JSX.Element => {
  const className = classNames('top-articles');

  return (
    <Wrapper className={className}>
      <Fixed>
        <Title>{RichText.asText(contentPage.top_insights)}</Title>
        {topArticles.map((topArticle: ITopArticle, index: number) => {
          return (
            <TopArticleWrapper key={index}>
              <ArticleLinkImage
                className="top-article"
                image={topArticle.article_image}
                url={RichText.asText(topArticle.seo_url)}
                title={RichText.asText(topArticle.title)}
              />
              <TopArticleMeta>
                <ArticleTitle
                  href={`${Routes.InsightsArticleId}${RichText.asText(
                    topArticle.seo_url
                  )}`}
                >
                  {RichText.asText(topArticle.title)}
                </ArticleTitle>

                {topArticle.author &&
                RichText.asText(topArticle.author) !== '' ? (
                  <ArticleAuthor>
                    {RichText.asText(topArticle.author)}
                  </ArticleAuthor>
                ) : null}
              </TopArticleMeta>
            </TopArticleWrapper>
          );
        })}
      </Fixed>
    </Wrapper>
  );
};
